import { Injectable } from '@angular/core';
import { MessagingNotification, MessagingRoutePayload, MessagingThread } from './messaging.models';

@Injectable({ providedIn: 'root' })
export class MessagingRouteService {
  buildThreadRoute(thread: MessagingThread): MessagingRoutePayload {
    return {
      screen: 'MessagingThread',
      routePath: '/app/messaging/thread',
      queryParams: { threadId: thread.threadId },
      threadId: thread.threadId,
      resourceType: thread.context?.contextType,
      resourceId: thread.context?.contextId
    };
  }

  resolveNotificationRoute(notification: MessagingNotification): MessagingRoutePayload {
    if (notification.route) {
      return notification.route;
    }

    if (notification.threadId) {
      return {
        screen: 'MessagingThread',
        routePath: '/app/messaging/thread',
        queryParams: { threadId: notification.threadId },
        threadId: notification.threadId,
        resourceType: notification.contextType,
        resourceId: notification.contextId
      };
    }

    return {
      screen: 'Notifications',
      routePath: '/app/notifications'
    };
  }

  resolveContextRoute(thread: MessagingThread): MessagingRoutePayload | null {
    const context = thread.context ?? {};

    if (context.serviceRequestId) {
// $#$      // /* alert("context.serviceRequestType" + JSON.stringify(context) */);
// $#$      /* alert("context.serviceRequestType" + ['metadata?.serviceRequestType']); */
      const type = context['metadata']?.['serviceRequestType'] || 'others';
      const routeSegment = type === 'laboratory' ? 'lab-tests' : type;

      // Check if we should use patient-scoped route
      const patientId = thread.subject?.resourceType === 'Patient' ? thread.subject.resourceId : null;
// $#$      /* alert("patientId" + patientId); */
      const routePath = patientId
        ? `/app/patients/${patientId}/service-requests/${routeSegment}`
        : `/app/service-requests/${routeSegment}`;

      return {
        screen: 'ServiceRequest',
        routePath: routePath,
        queryParams: { serviceRequestId: context.serviceRequestId },
        resourceType: 'ServiceRequest',
        resourceId: context.serviceRequestId,
        threadId: thread.threadId
      };
    }

    if (context.medicationRequestId) {
      return {
        screen: 'MedicationRequest',
        routePath: '/app/medicine-requests',
        queryParams: { medRequestId: context.medicationRequestId },
        resourceType: 'MedicationRequest',
        resourceId: context.medicationRequestId,
        threadId: thread.threadId
      };
    }

    if (context.medicationDispenseId) {
      return {
        screen: 'MedicationDispense',
        routePath: '/app/medication-dispense',
        queryParams: { dispenseId: context.medicationDispenseId },
        resourceType: 'MedicationDispense',
        resourceId: context.medicationDispenseId,
        threadId: thread.threadId
      };
    }

    if (context.diagnosticReportId) {
      return {
        screen: 'DiagnosticReport',
        routePath: '/app/diagnostic-reports',
        queryParams: { diagnosticReportId: context.diagnosticReportId },
        resourceType: 'DiagnosticReport',
        resourceId: context.diagnosticReportId,
        threadId: thread.threadId
      };
    }

    return null;
  }
}
